import React from "react";
import './landing_section.css'

// reactstrap components
import {
    Button,
    CardImg,
    CardText,
    CardSubtitle,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Container,
    Col,
    Row
} from "reactstrap";

class LANDING_SECTION extends React.Component {

    redirectTo(link) {
        window.location.href = link;
    }

    render() {
        return (
            <section id="home" className="landing fullpage-section">
                <div id="social-link-container">
                    <div onClick={() => { this.redirectTo("https://www.instagram.com/team__antriksh/")}}  className="social-link" id="insta-link"></div>
                    <div onClick={() => { this.redirectTo("https://www.youtube.com/channel/UCVBi-muWE6IaVRNGuCNk3sQ")}} className="social-link" id="youtube-link"></div>
                </div>
                <Row>
                    <Col xs="9" className="text_section"> 
                        <h1 className='title'>TEAM ANTRIKSH</h1>
                        {/* <img className='svgred' src={require("./../../assets/img/Rectangle 4.svg")} /> */}
                        <br/>
                        <h3 className='subtitle sm'>We are an interdisciplinary team from Manipal University Jaipur, India. Besides, we are ready to push limits of engineering challenges.</h3>
                    </Col>
                    {/* <Col xs="6"> */}
                        {/* <h1 className='bgtext'>MARS<br/>ROVER</h1> */}
                        {/* <img className='rover' src={require("./../../assets/img/rover nood.png")} /> */}
                    {/* </Col> */}
                </Row>
            </section>
        );
    }
}

export default LANDING_SECTION;
